import { render, staticRenderFns } from "./ImportRunList.vue?vue&type=template&id=5c396e63&scoped=true&"
import script from "./ImportRunList.vue?vue&type=script&lang=js&"
export * from "./ImportRunList.vue?vue&type=script&lang=js&"
import style0 from "./ImportRunList.vue?vue&type=style&index=0&id=5c396e63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c396e63",
  null
  
)

export default component.exports